module.exports = "pegasus_template/assets/loader_grey.gif";